import * as React from "react";
const SvgFiRrWorkflowSetting = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-workflow-setting_svg__a)">
      <path
        fill="#062147"
        d="M13 9h-2c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2m0 4h-2v-2h2zm0-12h-2c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2V3c0-1.103-.897-2-2-2m0 4h-2V3h2zm0 12h-2c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2m0 4h-2v-2h2zm10.866-10.613a1 1 0 0 1-1.366.366l-.76-.439A5 5 0 0 1 19 11.899V13a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1c1.654 0 3-1.346 3-3s-1.346-3-3-3a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v1.101a5 5 0 0 1 2.74 1.585l.76-.439a1 1 0 1 1 1 1.732l-.757.437a4.992 4.992 0 0 1 0 3.166l.757.437a1 1 0 0 1 .366 1.366zM7.414 18.586c.78.779.78 2.049 0 2.828l-1.793 1.793a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L5 21H3.5C1.57 21 0 19.43 0 17.5v-3C0 12.57 1.57 11 3.5 11H6a1 1 0 0 1 0 2H3.5c-.827 0-1.5.673-1.5 1.5v3c0 .827.673 1.5 1.5 1.5H5l-.793-.793a.999.999 0 1 1 1.414-1.414z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-workflow-setting_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWorkflowSetting;
